import { Injectable } from '@angular/core';
import { GridDetails, GridData, GridHeader } from '../../sample-tracking/tracking-overview/interfaces/grid';
import * as moment from 'moment';

@Injectable()
export class TrackingGridService {

    public defaultDateFormat = 'DD-MMM-YYYY';
    public defaultTimeFormat = 'HH:mm';

    /*
        works on checkbox change inside filter menu 
    */
    public searchOnFilterCheckBoxChange(grid: GridDetails, filterItems: GridData[]): GridData[] {
        let filteredItems = filterItems;
        if (filterItems && filterItems.length) {
            let isUnCheckedUniqueItems = [] as { isChecked: boolean, label: string, id: number }[];
            grid.header.
                forEach((gh) => {
                    if (gh.filteredUniqueItems) {
                        isUnCheckedUniqueItems = gh.filteredUniqueItems.filter(fui => !fui.isChecked);
                        isUnCheckedUniqueItems.forEach(icui => {
                            filteredItems = [
                                ...filteredItems.
                                    filter(
                                        // item => `${item[gh.key as keyof GridData]}`.
                                        //     indexOf(icui.label === '(Blanks)' ? null : icui.label) !== 0
                                        item => item[gh.key as keyof GridData] !==
                                            (icui.label === '(Blanks)' ? null : icui.label)
                                    )
                            ];
                        });
                    }
                });

            const sortedHeader = grid.header.find((gh: GridHeader) => !!gh.sort);
            if (sortedHeader && (sortedHeader.sort !== sortedHeader.prevSort)) {
                filteredItems = this.sortByHeader((!sortedHeader.sort || sortedHeader.sort === 'asc'), sortedHeader, filteredItems);
                sortedHeader.prevSort = sortedHeader.sort;
            }
        }
        return filteredItems;
    }

    /*
        works when typing on header searbox. 
    */
    public onHeaderSearch(grid: GridDetails, searchedItems: GridData[]): GridData[] {
        if (searchedItems && searchedItems.length) {
            const searchAppliedHeaders = grid.header.filter((gh: GridHeader) => gh.headerSearchText);
            searchAppliedHeaders.forEach(sah => {
                searchedItems = [
                    ...searchedItems.
                        filter(
                            (si: GridData) => `${si[sah.key as keyof GridData]}`.toLowerCase().indexOf(sah.headerSearchText === '-' ? null : sah.headerSearchText.toLowerCase()) !== -1
                        )
                ];
            });
        }
        return searchedItems;
    }

    /*
        used to sort the grid data.
    */
    public sortByHeader(isSortByAsc: boolean, header: GridHeader, gridData: GridData[]) {
        if (gridData && gridData.length) {
            return isSortByAsc ?
                gridData.sort((a, b) => {
                    const key = header.key as keyof GridData;
                    if (header.isDate || header.isDateTime) {
                        return !a[key] ? 1 : !b[key] ? -1 : +new Date(`${a[key]}`) - +new Date(`${b[key]}`);
                    } else {
                        return `${a[key]}`
                            .localeCompare(`${b[key]}`, undefined, {
                                numeric: true,
                                sensitivity: 'base'
                            });
                    }
                }) :
                gridData.reverse();
        }
        return gridData;
    }

    /*
        used to get uniqueValues of each column.
    */
    public setUniqueValues(grid: GridDetails) {
        grid.header.forEach((gh: GridHeader) => {
            if (gh.enableFilter) {
                gh.filteredUniqueItems = gh.uniqueItems = [...new Set(grid.data.
                    map((gd: GridData) => gd[gh.key as keyof GridData])
                )].
                    sort((a: any, b: any) => {
                        if (gh.isDate || gh.isDateTime) {
                            return a === '' ? -1 : b === '' ? 1 : (new Date(a) > new Date(b)) ? 1 : (new Date(a) < new Date(b)) ? -1 : 0;
                        }
                        return a === null ? -1 : b === null ? 1 : a.toString().
                            localeCompare(b, undefined, {
                                numeric: true,
                                sensitivity: 'base'
                            });
                    }).
                    map((ui: string, i: number) => {
                        return ({
                            isChecked: true,
                            label: ui || '(Blanks)',
                            id: i
                        });
                    });
            }
        });
    }

    public setUniqueValuesOfHeader(grid: GridDetails, gridHeader: GridHeader) {
        gridHeader.filteredUniqueItems = gridHeader.uniqueItems = [...new Set(grid.data.
            map((gd: GridData) => gd[gridHeader.key as keyof GridData])
        )].
            sort((a: any, b: any) => {
                return a === null ? -1 : b === null ? 1 : a.toString().
                    localeCompare(b, undefined, {
                        numeric: true,
                        sensitivity: 'base'
                    });
            }).
            map((ui: string, i: number) => {
                return ({
                    isChecked: true,
                    label: ui || '(Blanks)',
                    id: i
                });
            });
    }

    public dateFormatter(grid: GridDetails) {
        const dateField = grid.header.filter(gh => gh.isDate);
        const timeField = grid.header.filter(gh => gh.isTime);
        if ((!dateField || dateField.length === 0) && (!timeField && timeField.length === 0)) { return grid; }
        const defaultDateFormat = 'DD-MMM-YYYY';
        const defaultTimeFormat = 'HH:mm';
        if (grid && grid.data && grid.header && grid.header.length) {
            grid.data.forEach((gd: any) => {

                dateField.forEach((df: GridHeader) => {
                    const valueField = (df.primaryField || df.key) as keyof GridData;
                    df.skipConversion = true;
                    gd[df.key as keyof GridData] = gd[valueField] ?
                        moment(gd[valueField]).format(df.defaultDateFormat || defaultDateFormat) : null;
                });

                timeField.forEach((df: GridHeader) => {
                    const valueField = (df.primaryField || df.key) as keyof GridData;
                    df.skipConversion = true;
                    gd[df.key as keyof GridData] = gd[valueField] ?
                        moment(gd[valueField]).format(df.defaultTimeFormat || defaultTimeFormat) : null;
                });
            });
        }
        return grid;
    }
}